export default (that) => [
  {
    field: "seq",
    minWidth: 70,
    align: "center",
    fixed: "left",
    type: "seq",
  },
  {
    field: "col-opt",
    title: that.$l("INDEX.table_label_operation") || "操作",
    headerAlign: "center",
    align: "center",
    minWidth: 160,
    fixed: "right",
    slots: {
      default: "opt",
    },
  },
  {
    title: that.$l('table_lable_purchasePackageNo')||"包装采购单号",
    field: "purchasePackageNo",
    headerAlign: "center",
    align: "center",
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("INDEX.order_form_label_orderNo") || "订单编号",
    field: "orderNo",
    headerAlign: "center",
    align: "center",
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_buyerName')||"采购人",
    field: "buyerName",
    headerAlign: "center",
    align: "center",
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.purchase_form_label_scmCode')||"供应商",
    field: "scmName",
    headerAlign: "center",
    align: "center",
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_purchaseDate')||"采购日期",
    field: "purchaseDate",
    headerAlign: "center",
    align: "center",
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_purchaseStatus')|| "采购单状态",
    headerAlign: "center",
    align: "center",
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: "status",
    },
  },
  {
    title: that.$l('table_label_contactName')||"供应商联系人",
    field: "contactName",
    headerAlign: "center",
    align: "center",
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_contact_mobile')||"联系人手机",
    field: "contactMobile",
    headerAlign: "center",
    align: "center",
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_receiveContact')||"收货联系人",
    field: "receiveContact",
    headerAlign: "center",
    align: "center",
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_receiveContactMobile')||"收货联系人手机",
    field: "receiveContactMobile",
    headerAlign: "center",
    align: "center",
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_receiverAddress')||"收货地址",
    field: "receiveAddress",
    headerAlign: "center",
    align: "center",
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_packaging_amount')||"包装金额",
    field: "packageAmount",
    headerAlign: "center",
    align: "center",
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_surcharge')||"附加费用",
    field: "surcharge",
    headerAlign: "center",
    align: "center",
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title:that.$l('table_label_totalAmount')|| "金额合计",
    field: "totalAmount",
    headerAlign: "center",
    align: "center",
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.creator')||"创建人",
    headerAlign: "center",
    align: "center",
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: "createInfo",
    },
  },
  {
    title: that.$l('INDEX.table_label_modified_by')||"修改人",
    headerAlign: "center",
    align: "center",
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: "modifyInfo" },
  },
  {
    title: that.$l('INDEX.table_label_reviewer_by_name')||"审核人",
    headerAlign: "center",
    align: "center",
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: "reviewInfo",
    },
  },
  {
    title: that.$l('INDEX.table_label_remarks')||"备注说明",
    field: "remark",
    headerAlign: "center",
    align: "center",
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
